export const getStep = ()=>{
    return .01
}